import { Inject, Injectable } from '@angular/core';
import { AuthServiceInterface } from '../auth/auth-service.interface';
import { UserResponse } from '../auth/responses/user.response';
import { RbacPermissionsConstant } from './rbac-permissions.constant';
import { RbacServiceInterface } from './rbac-service.interface';

@Injectable()
export class RbacService implements RbacServiceInterface {
  constructor(@Inject('AuthServiceInterface') private authService: AuthServiceInterface) {}

  isRole(role: number, user?: UserResponse): boolean {
    if (!role) {
      return false;
    }
    const currentUser = user ? user : this.authService.userData();
    if (currentUser) {
      if (currentUser.roles) {
        return !!currentUser.roles[role];
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  can(permissions: any): boolean {
    if (!permissions) {
      return false;
    }
    const user = this.authService.userData();
    if (user) {
      if (user.permissions) {
        switch (typeof permissions) {
          case 'string':
            return !!user.permissions[permissions];
          case 'object':
            if (Array.isArray(permissions)) {
              for (const permission of permissions) {
                if (user.permissions[permission]) {
                  return true;
                }
              }
              return false;
            }
            break;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  canEvery(value: string | string[] | undefined | null): boolean {
    if (!value) {
      return true;
    }
    const permissions = this.authService.userData()?.permissions;
    if (permissions) {
      return Array.isArray(value) ? value.every((item) => permissions[item]) : permissions[value];
    }
    return true;
  }

  canAction(permission: string | string[]): boolean {
    if (!permission) {
      return true;
    }

    const user = this.authService.userData();
    if (!user) {
      return true;
    }

    const permissions = Array.isArray(permission) ? [...permission] : [permission];

    let permissionCounter = 0;

    for (const perm of permissions) {
      if (user.permissions[perm]) {
        permissionCounter++;
      }
    }

    if (user.permissions[RbacPermissionsConstant.SCOPES_VIEW_ONLY]) {
      permissionCounter = 0;
    }

    return permissions.length === permissionCounter;
  }
}
